import productSaga from './saga';

export default productSaga;
